import { ENV_CONFIG } from 'config/environment';
import { useMemo } from 'react';
import { components } from 'react-select';
import type { IAdminRecipient } from 'store/admins/types';

export const useRecipientOptions = (recipients: IAdminRecipient[] = []) => {
  return useMemo(() => {
    return (recipients || []).map(item => {
      const logoUrl = `${ENV_CONFIG().CLOUD_STORAGE.URL}/recipients/rec_${item.photo_id}.jpg`;
      return {
        value: item.id,
        label: item.name,
        logoUrl,
        subtitle: '',
      };
    });
  }, [recipients]);
};

export const RecipientOption = (props: any) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <div className="recipient-option">
        <div className="navbar-user">
          <span className="oath-body inkBlue">{data.label}</span>
          {data.subtitle ? <span className="oath-utility inkBlue">{data.subtitle}</span> : null}
        </div>
      </div>
    </components.Option>
  );
};
